import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {UUID} from '../../../shared/types/uuid.type';
import {ApiV2Service} from '../api-v2';
import {CreateStreamTranscodingConfigurationDto, StreamTranscodingConfiguration} from './stream-transcoding-configuration.interface';

@Injectable({
  providedIn: 'root'
})
export class StreamTranscodingConfigurationsService {
  private readonly RESOURCE_BASE: string = '/streams/transcoding';

  constructor(
    private readonly api: ApiV2Service
  ) {
  }

  public getAll(): Observable<StreamTranscodingConfiguration[]> {
    return this.api.get<StreamTranscodingConfiguration[]>(this.RESOURCE_BASE);
  }

  public create(
    dto: CreateStreamTranscodingConfigurationDto
  ): Observable<StreamTranscodingConfiguration> {
    return this.api.post<StreamTranscodingConfiguration>(this.RESOURCE_BASE, dto);
  }

  public resume(
    id: UUID
  ): Observable<StreamTranscodingConfiguration> {
    return this.api.post<StreamTranscodingConfiguration>(`${this.RESOURCE_BASE}/${id}/start`, {});
  }

  public stop(
    id: UUID
  ): Observable<StreamTranscodingConfiguration> {
    return this.api.post<StreamTranscodingConfiguration>(`${this.RESOURCE_BASE}/${id}/stop`, {});
  }

  public delete(
    id: UUID
  ): Observable<void> {
    return this.api.delete<void>(`${this.RESOURCE_BASE}/${id}`);
  }
}

